var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.keyboardClass,style:(this.keyboardType == 'sms' ? 'max-width: 30%; margin: 0 auto;' :  '')})}
var staticRenderFns = []

export { render, staticRenderFns }